import { PLATFORM } from '@/constants/platform'
import { useAuthStore } from '@/stores/useAuthStore'
import {
  AddRecipientFormData,
  DistributionListAddRecipientSportData,
  DistributionListDeleteRecipientData,
  DistributionListDeleteRecipientSportData
} from '@/types/dde/distributionList'

import { DDE_ENDPOINTS } from './constants/ddeEndpoints'
import { deleteData, postData, putData } from './request'

export function addDistributionListRecipient(data: AddRecipientFormData) {
  const platform = useAuthStore.getState().platform

  if (platform === PLATFORM.DDE) {
    return postData({
      endpointData: DDE_ENDPOINTS.Timeline.Emails.post,
      data: {
        ...data,
        operatorId: data.operatorId ? parseInt(data.operatorId) : null,
        sports: data.sports || []
      }
    })
  }

  throw new Error('Unsupported platform')
}

export function deleteDistributionListRecipient(data: DistributionListDeleteRecipientData) {
  const platform = useAuthStore.getState().platform

  if (platform === PLATFORM.DDE) {
    return deleteData({ endpointData: DDE_ENDPOINTS.Timeline.Emails.delete, data })
  }

  throw new Error('Unsupported platform')
}

export function addDistributionListRecipientSport(data: DistributionListAddRecipientSportData) {
  const platform = useAuthStore.getState().platform

  if (platform === PLATFORM.DDE) {
    return putData({ endpointData: DDE_ENDPOINTS.Timeline.Emails.Sports.put, data })
  }

  throw new Error('Unsupported platform')
}

export function deleteDistributionListRecipientSport(
  data: DistributionListDeleteRecipientSportData
) {
  const platform = useAuthStore.getState().platform

  if (platform === PLATFORM.DDE) {
    return deleteData({ endpointData: DDE_ENDPOINTS.Timeline.Emails.Sports.delete, data })
  }

  throw new Error('Unsupported platform')
}
